import React, { Fragment } from "react";
import { useRouter } from "next/router";
import Link from "next/link";
import { UniHeroWithVideo, UniBrief, UniLinks, UniProfileBanner } from ".";
import { generateNavTitle } from "@unisearch/helpers";
import styles from "./uni_profile_wrapper.module.scss";
import useWindowDimensions from "_hooks/useWindowDimensions";

export const UniProfileWrapper = ({
  isVideoBanner = true,
  isBanner = true,
  isBreadcrumb = true,
  breadcrumbTitle,
  children,
  ...props
}) => {
  const uniProfileData = props.uniProfileData;
  const { width } = useWindowDimensions();

  const router = useRouter();
  const { query, pathname } = router;
  const targetPathSlug = pathname.split("/")[5];
  const { course_slug } = query;

  const breadCrumbActiveLink = () => {
    return (
      <span className="color-orange">
        {breadcrumbTitle ? breadcrumbTitle : generateNavTitle(targetPathSlug)}
      </span>
    );
  };

  return (
    <Fragment>
      {isBanner && (
        <>
          {uniProfileData?.videoType && isVideoBanner ? (
            <UniHeroWithVideo uniProfileData={uniProfileData} />
          ) : (
            <UniProfileBanner uniProfileData={uniProfileData} />
          )}
        </>
      )}

      <UniBrief
        uniProfileData={uniProfileData}
        customClasses={{ root: !isBanner ? styles.root : "" }}
      />
      <UniLinks uniProfileData={uniProfileData} />

      {(isBanner || width < 992) && (
        <div className={styles.uni_breacrumbs}>
          <Link href="/">Home</Link>
          <Link href={`/${uniProfileData?.countrySlug}/university`}>
            Universities in {uniProfileData?.CountryName}
          </Link>
          <Link
            href={`/study/${uniProfileData?.countrySlug}/university/${uniProfileData?.universitySlug}`}
          >
            {uniProfileData?.universityName}
          </Link>
          {targetPathSlug && breadCrumbActiveLink()}
        </div>
      )}
      {children}
    </Fragment>
  );
};

export default UniProfileWrapper;
